(function () {
  'use strict';

  var lists = document.querySelectorAll('[data-ymazo-geo-links]');
  if (!lists.length) return;

  fetch('https://geo.auozo.com/v1/access', {
    method: 'GET',
    mode: 'cors',
    credentials: 'omit',
    cache: 'no-store',
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      if (!response.ok) throw new Error('geo endpoint returned ' + response.status);
      return response.json();
    })
    .then(function (result) {
      if (!result || result.footerAllowed !== true) return;
      lists.forEach(function (list) {
        list.hidden = false;
      });
    })
    .catch(function () {
      // Fail closed: policy links remain hidden when location cannot be verified.
    });
})();
